/*/
(function () {
	// Fix Bootstrap Modal Stacking
	var modals = document.querySelectorAll('.modal');

	for (var i = 0; i < modals.length; i++) {
		document.body.appendChild(modals[i]);
	}
})();
/*/


/*/ ==========================================================================
	GET URL PARAMETER FUNCTION
	http://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js
========================================================================== /*/

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};


/*/ ==========================================================================
	LINK DIRECTLY TO TABS AND MODALS v2.0
	Updated on May 25, 2017
========================================================================== /*/

$(function() {
	var modal = getUrlParameter('modal'), tab = getUrlParameter('tab');

	if (modal !== undefined) {
      	$('#modal-' + modal).modal('show');
		$('#modal_' + modal).modal('show');
	}

	if (tab !== undefined) {
		$('a[href="#tab-' +tab+ '"]').tab('show');
	}
});


/*/ ==========================================================================
	SCREEN SIZE / DEVICE DETECTION
	Updated on February 22, 2016
	Based on new Corporate website code
========================================================================== /*/

function checkRange(x, n, m) {
	if (x >= n && x <= m) { return x; }
	else { return !x; }
}

function deviceInfo() {
	var screenWidth = $(document).width(); // get the document width
	var screenType;
	var deviceType;

	switch (screenWidth) {
		case checkRange(screenWidth, 0, 767):
			screenType = 'screen-xs';
			deviceType = 'phone';
			$('.slider-desktop').remove();
			break;
		case checkRange(screenWidth, 768, 991):
			screenType = 'screen-sm';
			deviceType = 'tablet';
			$('.slider-mobile').remove();
			break;
		case checkRange(screenWidth, 992, 1199):
			screenType = 'screen-md';
			deviceType = 'desktop';
			$('.slider-mobile').remove();
			break;
		default:
			screenType = 'screen-lg';
			deviceType = 'desktop';
	}

	$("body").removeClass("screen-xs screen-sm screen-md screen-lg phone tablet desktop").addClass(screenType + ' ' + deviceType);

	return {
		"size": screenType,
		"type": deviceType
	}
}


/*/ ==========================================================================
	Mobile Browser Menu
========================================================================== /*/

$("select.mobile-nav").change(function() {
    var data_target = $(this).find("option:selected").val();
  	$('a[href="' + data_target + '"]').tab('show');
});


/*/ ==========================================================================
	Select Active Blueplate Tab
========================================================================== /*/

var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
var day_index = new Date().getDay();

$('.nav-menu-week a[href="#' +days[day_index]+ '"]').tab('show')

$(".modal").on('show.bs.modal', function (e) {
	$(this).find('img').each(function(i) {
		$(this).attr("src",$(this).attr('data-src'));
    });
});
